var React = require('react');

function ArrowDownSmallInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M10.563 13L14 9.696l-.745-.69-2.706 2.602L7.73 9 7 9.702 10.563 13z"}));
}

ArrowDownSmallInline.defaultProps = {"viewBox":"0 0 22 22"};

module.exports = ArrowDownSmallInline;

ArrowDownSmallInline.default = ArrowDownSmallInline;
